<template>
  <ol-vector-layer
    zIndex="1"
    className="dts-map-vector-layer"
    :opacity="opacity"
    :visible="isVisible"
  >
    <ol-source-vector>
      <ol-feature v-for="(sensor, index) in sensorReadings.slice(0, -1)" :key="index">
        <ol-geom-line-string
          :coordinates="[
            [sensorReadings[index].coordinate?.easting, sensorReadings[index].coordinate?.northing],
            [
              sensorReadings[index + 1].coordinate?.easting,
              sensorReadings[index + 1].coordinate?.northing
            ]
          ]"
        ></ol-geom-line-string>
        <ol-style-flowline
          :color="getColor(sensor.dts)"
          :color2="getNextColor(index)"
          :width="strokeWidth"
          :width2="strokeWidth"
          :arrow="0"
          lineCap="round"
        />
      </ol-feature>
    </ol-source-vector>
  </ol-vector-layer>
</template>

<script setup lang="ts">
import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { TEMPERATURE_CONFIG } from '@/constants/temperatureConstants'
import { defineProps, PropType, ref } from 'vue'

const strokeWidth = ref(18)
const opacity = ref(1)

const props = defineProps({
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
})

const getColor = (dts: number | undefined | null) => {
  if (dts === undefined || dts === null) {
    return 'rgba(0, 0, 0, 0)'
  }

  const { colors, thresholds } = TEMPERATURE_CONFIG
  
  if (dts < thresholds.low) {
    return colors[0]
  } else if (dts >= thresholds.low && dts < thresholds.medium) {
    return colors[1]
  } else if (dts >= thresholds.medium && dts < thresholds.high) {
    return colors[2]
  } else {
    return colors[3]
  }
}

const getNextColor = (index: number) => {
  const sensorReading = props.sensorReadings[index + 1]
  return getColor(sensorReading.dts)
}
</script>

<style>
.dts-map-vector-layer {
  filter: blur(8px);
}
</style>
